import firebase from 'firebase/compat';
import { ServiceStatusSnakeCaseTypes, ServiceStatusTypes } from '../enums';
import Timestamp = firebase.firestore.Timestamp;

export interface ServiceResponseData {
  id?: string;
  address: string;
  addressFull: string;
  fromDirectory: string;
  memberName: string;
  memberProfileUid: string;
  pathToProcessorService: string;
  confirmationIds?: string[];
  productId: string;
  jobId: number;
  numOfFinals: number;
  numOfRaws: number;
  received: number;
  briefs: Brief[]
  searchTags: string[];
  notifications: any;
  createdAt: Timestamp;
  lastUpdated: Timestamp;
  serviceType: ServiceTypes;
  displayName: ServiceDisplayNameTypes
  status: ServiceStatusTypes;
  statusSnakeCase: ServiceStatusSnakeCaseTypes;
  timelineEvents: TimelineEvents
}


export interface Service extends ServiceResponseData {
  images?: string[];
  assetsData?: any;
  isSelected?: boolean;
  imagesToDeliver?: any;
}

export enum ServiceTypesEnum {
  IMAGE_SERVICE = 'imageService',
  VIDEO_SERVICE = 'videoService',
  FLOORPLAN_SERVICE = 'floorplanService',
}

export enum ServiceDisplayNameEnum {
  IMAGE_SERVICE = "Image Service",
  VIDEO_SERVICE = "Video Service",
  FLOORPLAN_SERVICE = "Floorplan Service"
}

export type ServiceDisplayNameTypes =  ServiceDisplayNameEnum.IMAGE_SERVICE | ServiceDisplayNameEnum.VIDEO_SERVICE | ServiceDisplayNameEnum.FLOORPLAN_SERVICE;

export type ServiceTypes = ServiceTypesEnum.IMAGE_SERVICE | ServiceTypesEnum.VIDEO_SERVICE | ServiceTypesEnum.FLOORPLAN_SERVICE;

export interface Brief {
  brief: string;
  briefTimestamp: string;
  numOfFinals: string;
}

export interface TimelineEvents {
  [timestamp: number]: {
    date: Timestamp
    event: string
    eventType: serviceEventType
  }
}

export const enum ServiceEventEnums {
  CREATION = 'created',
  UPDATE = 'updated',
  REJECTION = 'correction_requested',
  DELIVERY = 'delivered'
}

export type serviceEventType = ServiceEventEnums.CREATION | ServiceEventEnums.UPDATE | ServiceEventEnums.REJECTION | ServiceEventEnums.DELIVERY
